<template>
    <TextBox class="evaluation-card">
        <h5 :class="{correct}">
            <slot name="header" />
        </h5>
        <div>
            <slot />
        </div>
        <div class="text-right">
            <ControlButton
                active
                class="next-button"
                @click="slideTo(1)"
            >
                Okay
            </ControlButton>
        </div>
    </TextBox>
</template>

<script>
import DirectionSlider from '@/mixins/DirectionSlider';

export default {
    name: 'EvaluationCard',
    mixins: [DirectionSlider],
    props: {
        correct: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" src="./EvaluationCard.scss" />

